import HttpClient from '@/utility/http-client';
import { Comment } from '@/models/comment';

export default {
    getComment(orderId: any, orderType: any) {
        return HttpClient.instance().get(`/api/order_comment/?OrderID=${orderId}&OrderType=${orderType}`);
    },

    addComment(comment: Comment) {
        return HttpClient.instance().put(`/api/order_comment/`, comment);
    },
};
